module.exports = __webpack_public_path__ + "static/media/3-show-programmy.c78bef24.jpg";